import { z } from 'zod';

/**
 * The six Strata roles (CLAUDE.md §1). Single source of truth — `packages/config/rbac.ts`
 * (M02) maps Azure AD group claims onto these and defines the role × action matrix.
 */
export const ROLES = [
  'energy_engineer', // analytics, balance, opportunities, M&V
  'mv_officer', // baselines, IPMVP verification, savings sign-off
  'operations', // site dashboards, alerts
  'management', // read-only cockpit and reports
  'auditor', // read-only ISO 50001 evidence + audit log
  'admin', // config, users, assets, integrations
] as const;

export const RoleSchema = z.enum(ROLES);
export type Role = z.infer<typeof RoleSchema>;

/** Human-readable labels for UI. */
export const ROLE_LABELS: Record<Role, string> = {
  energy_engineer: 'Energy Engineer',
  mv_officer: 'M&V Officer',
  operations: 'Operations User',
  management: 'Management Viewer',
  auditor: 'External Auditor',
  admin: 'Administrator',
};

/** Roles that may never hit a mutating route (RBAC default-deny, CLAUDE.md §12.2). */
export const READ_ONLY_ROLES: readonly Role[] = ['management', 'auditor'] as const;
